<template>
    <v-container fluid class="px-0">
        <!-- Tabella visibile se ci sono dei dettagli gia salvati-->
        <v-data-table
            v-if="tot_dettagli_servizio.length > 0"
            :headers="headers"
            fixed-header
            :items="
                items_dettagli_servizio
                    .filter((d) => d.validita == true)
                    .reverse()
            "
            :items-per-page="10"
            item-key="id_servizio_dettaglio"
            class="elevation-1"
            calculate-widths
            height="60vh"
        >
            <!-- Intestazione tabella -->
            <template v-slot:top>
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <!-- Aggiungi servizio 
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="nuovoDettaglio"
                class="ml-auto mr-5"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
<span>Nuova Opzione</span>
</v-tooltip>-->
                    <!-- Visualizza filtri 
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-auto ml-5"
                v-bind="attrs"
                v-on="on"
                small
                @click="
                  filters == true
                    ? ((filters = false), resetFiltri())
                    : (filters = true)
                "
              >
                <v-icon color="purple">
                  {{ filters == true ? "mdi-filter-off" : "mdi-filter" }}
                </v-icon>
              </v-btn>
            </template>
            <span v-if="filters == false">Visualizza Filtri</span>
            <span v-else>Nascondi Filtri</span>
          </v-tooltip> -->
                </v-toolbar>
                <!-- Row Filtri -->
                <v-row v-if="filters === true" justify="center" class="ma-1">
                    <v-col cols="3">
                        <v-text-field
                            @input="filtra"
                            label="Codice"
                            v-model="codice_filter"
                            dense
                            hide-details
                            class="mt-5"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            @change="filtra"
                            label="Descrizione"
                            v-model.number="id_tipo_servizio_dettaglio_filter"
                            dense
                            hide-details
                            :items="items_dettagli_tipo"
                            class="mt-5"
                            item-text="descrizione"
                            item-value="id_tipo_servizio_dettaglio"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            @change="filtra"
                            label="Veicolo"
                            v-model.number="id_tipo_macchina_filter"
                            dense
                            hide-details
                            :items="tipo_veicolo"
                            class="mt-5"
                            item-text="des"
                            item-value="id_tabella"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            @change="filtra"
                            label="Materiale"
                            v-model.number="id_materiale_filter"
                            dense
                            hide-details
                            :items="items_materiali"
                            class="mt-5"
                            item-text="codice_des"
                            item-value="id_materiale"
                        />
                    </v-col>
                </v-row>
            </template>
            <!-- Pulsante edit -->
            <template v-slot:[`item.edit`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="
                                selectItem(item);
                                create_edit_dialog = true;
                                search_articolo = item.des_articolo;
                            "
                        >
                            <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Dettagli</span>
                </v-tooltip>
            </template>
            <!-- Pulsante richiedi fir -->
            <template v-slot:[`item.fir`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="item.id_fir != null"
                            v-on="on"
                            v-bind="attrs"
                            small
                            @click="generaFir(item)"
                        >
                            <v-icon color="primary">mdi-recycle</v-icon>
                        </v-btn>
                    </template>
                    <span>Genera fir</span>
                </v-tooltip>
            </template>
            <!-- Pulsante stampa report -->
            <template v-slot:[`item.report`]="{ item }">
                <v-btn small @click="getReport(item)">
                    <v-icon color="primary">mdi-printer</v-icon>
                </v-btn>
            </template>
            <!-- Pulsante Invia Dati (formulario) -->
            <template v-slot:[`item.InviaDati`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            small
                            @click="inviaDatiFormulario(item)"
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-icon color="primary">mdi-arrow-up</v-icon>
                        </v-btn>
                    </template>
                    <span>Invia dati e crea formulario</span>
                </v-tooltip>
            </template>
            <!-- Pulsante stampa PDF formulario -->
            <!-- <template v-slot:[`item.PDFFormulario`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              @click="getPDFFormulario(item)"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon color="primary">mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Stampa PDF</span>
        </v-tooltip>
      </template> -->
            <!-- Pulsante cambia stato -->
            <template v-slot:[`item.changestato`]="{ item }">
                <v-btn
                    small
                    @click="
                        selectItem(item);
                        cambia_stato_dialog = true;
                    "
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-on="on"
                                :attrs="attrs"
                                :color="
                                    items_stato.filter(
                                        (i) => i.id_tabella == item.id_stato
                                    ).length > 0
                                        ? items_stato.find(
                                              (i) =>
                                                  i.id_tabella == item.id_stato
                                          ).val_txt
                                        : 'error'
                                "
                            >
                                {{
                                    items_stato.filter(
                                        (i) => i.id_tabella == item.id_stato
                                    ).length > 0
                                        ? items_stato.find(
                                              (i) =>
                                                  i.id_tabella == item.id_stato
                                          ).nota_interna
                                        : "mdi-close-thick"
                                }}
                            </v-icon>
                        </template>
                        <span>
                            {{
                                items_stato.filter(
                                    (i) => i.id_tabella == item.id_stato
                                ).length > 0
                                    ? items_stato.filter(
                                          (i) => i.id_tabella == item.id_stato
                                      )[0].des
                                    : "N/D"
                            }}
                        </span>
                    </v-tooltip>
                </v-btn>
            </template>
            <!-- tipo materiale -->
            <template v-slot:[`item.id_tipo_materiale`]="{ item }">
                {{
                    tot_items_tipo_rifiuto.filter(
                        (i) => i.id_tipo_materiale == item.id_tipo_materiale
                    ).length > 0
                        ? tot_items_tipo_rifiuto.filter(
                              (i) =>
                                  i.id_tipo_materiale == item.id_tipo_materiale
                          )[0].descrizione
                        : "N/D"
                }}
            </template>
            <template v-slot:[`item.id_tipo_macchina`]="{ item }">
                {{
                    tipo_veicolo.filter(
                        (i) => i.id_tabella == item.id_tipo_macchina
                    ).length > 0
                        ? tipo_veicolo.filter(
                              (i) => i.id_tabella == item.id_tipo_macchina
                          )[0].des
                        : "N/D"
                }}
            </template>
            <template v-slot:[`item.id_tipo_servizio_dettaglio`]="{ item }">
                {{
                    items_dettagli_tipo.filter(
                        (i) =>
                            i.id_tipo_servizio_dettaglio ==
                            item.id_tipo_servizio_dettaglio
                    ).length > 0
                        ? items_dettagli_tipo.filter(
                              (i) =>
                                  i.id_tipo_servizio_dettaglio ==
                                  item.id_tipo_servizio_dettaglio
                          )[0].descrizione
                        : "N/D"
                }}
            </template>
            <!-- Pulsante rimuovi 
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                delete_dialog = true;
              "
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template> -->
        </v-data-table>

        <!-- Create template -->
        <!-- Template visibile al posto della tabella solo se non ci sono dettagli gia salvati -->
        <template v-else>
            <!-- Input -->
            <v-row justify="center" class="mx-2">
                <v-col cols="4">
                    <v-autocomplete
                        label="Descrizione servizio"
                        v-model.number="
                            selected_item.id_tipo_servizio_dettaglio
                        "
                        dense
                        hide-details
                        :items="items_dettagli_tipo"
                        item-text="descrizione"
                        item-value="id_tipo_servizio_dettaglio"
                    />
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                        @change="getVolumiRifiuti()"
                        v-model.number="selected_item.id_tipo_macchina"
                        label="Tipo Rimorchio"
                        dense
                        :items="tipo_veicolo"
                        hide-details
                        item-text="des"
                        item-value="id_tabella"
                    />
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        @change="getVolumiRifiuti()"
                        v-model.number="selected_item.id_tipo_materiale"
                        :items="items_tipo_rifiuto"
                        dense
                        :readonly="selected_item.id_tipo_macchina == null"
                        @click="
                            selected_item.id_tipo_macchina == null
                                ? message('Selezionare il tipo rimorchio')
                                : null
                        "
                        label="Tipo Rifiuto"
                        hide-details
                        item-text="descrizione"
                        item-value="id_tipo_materiale"
                    />
                </v-col>
                <v-col cols="6">
                    <v-autocomplete
                        label="Materiale"
                        v-model.number="selected_item.id_materiale"
                        dense
                        hide-details
                        :items="items_materiali"
                        item-text="codice_des"
                        item-value="id_materiale"
                    >
                    </v-autocomplete>
                </v-col>

                <v-col cols="2">
                    <v-autocomplete
                        v-model.number="selected_item.volume"
                        label="Volume"
                        dense
                        @change="
                            selected_item.volume && unita_misura.length > 0
                                ? (selected_item.um_volume = unita_misura.find(
                                      (um) => um.volume === selected_item.volume
                                  ).um_volume)
                                : null
                        "
                        :items="items_volumi"
                        hide-details
                        :readonly="
                            selected_item.id_tipo_macchina == null ||
                            selected_item.id_tipo_materiale == null
                        "
                        @click="
                            selected_item.id_tipo_macchina == null
                                ? message('Selezionare il tipo rimorchio')
                                : selected_item.id_tipo_materiale == null
                                ? message('Selezionare il tipo rifiuto')
                                : null
                        "
                        item-text="volume"
                        item-value="volume"
                    />
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        @click="
                            selected_item.volume == null ||
                            selected_item.volume == ''
                                ? message('Selezionare il volume')
                                : null
                        "
                        :value="
                            selected_item.volume && unita_misura.length > 0
                                ? unita_misura.find(
                                      (um) =>
                                          um.um_volume ===
                                          selected_item.um_volume
                                  ).misura
                                : ''
                        "
                        model-value="misura"
                        label="U.M."
                        dense
                        readonly
                        hide-details
                    />
                </v-col>

                <!-- <v-col cols="1">
          <v-text-field v-model.number="selected_item.quantita_origine" label="Qta Origine (Kg)" dense hide-details
            type="number" />
        </v-col>
        <v-col cols="1">
          <v-text-field v-model.number="selected_item.quantita_destino" label="Qta Destino (Kg)" dense hide-details
            type="number" />
        </v-col> -->
                <v-col cols="2">
                    <v-text-field
                        v-model.number="selected_item.num_big_bag"
                        type="number"
                        label="N° Big Bag"
                        hide-spin-buttons
                        dense
                        hide-details
                    >
                    </v-text-field>
                </v-col>

                <v-col cols="6">
                    <v-text-field
                        @keyup.enter.native="searchListiniArticoli()"
                        :readonly="this.selected_item.id_articolo != null"
                        v-model="search_articolo"
                        label="Articolo"
                        hide-spin-buttons
                        dense
                        hide-details
                    >
                    </v-text-field>
                </v-col>

                <!-- Pulsante sync articoli. -->
                <v-col cols="2">
                    <div class="d-flex bg-surface-variant">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="searchListiniArticoli()"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    :disabled="
                                        selected_item.id_articolo != null
                                    "
                                >
                                    <v-icon color="primary">
                                        mdi-magnify
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Trova articoli</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-5"
                                    @click="resetArticolo"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    :disabled="
                                        selected_item.id_articolo == null
                                    "
                                >
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </template>
                            <span>Rimuovi articolo</span>
                        </v-tooltip>
                    </div>
                </v-col>

                <v-col cols="3">
                    <v-text-field
                        v-model.number="selected_item.frequenza_ripetizione_ore"
                        label="Frequenza ripetizioni"
                        dense
                        type="number"
                        hide-details
                    />
                </v-col>
                <v-col cols="1">
                    <v-autocomplete
                        v-model.number="selected_item.um_frequenza_ripetizione"
                        label="U.M."
                        dense
                        hide-details
                        item-text="des"
                        item-value="id_tabella"
                        :items="items_um_tempo"
                    />
                </v-col>

                <!-- Colonna padding. -->
                <!-- <v-col cols="5"></v-col> -->

                <v-col cols="2">
                    <v-text-field
                        v-model.number="selected_item.costo_servizio"
                        type="number"
                        label="Costo servizio"
                        hide-spin-buttons
                        dense
                        hide-details
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        v-model.number="selected_item.credito_azienda"
                        type="number"
                        label="Credito azienda"
                        hide-spin-buttons
                        dense
                        hide-details
                    >
                    </v-text-field>
                </v-col>

                <v-col cols="3">
                    <v-autocomplete
                        v-model.number="selected_item.id_pagamento"
                        label="Tipo Pagamento"
                        dense
                        :items="items_tipo_pagamento"
                        hide-details
                        item-text="des_pagamento"
                        item-value="id_pagamento"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        dense
                        required
                        hide-details
                        label="Intermediario"
                        v-model="selected_item.intermediario"
                        @keyup.enter.native="goToAnagrafica()"
                    >
                        <template v-slot:append>
                            <v-icon
                                class="ml-2"
                                @click="goToAnagrafica()"
                                color="primary"
                                >mdi-magnify</v-icon
                            >
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="11">
                    <!-- ROW per ciclare i campi di input presi dal db -->
                    <v-row>
                        <v-col
                            cols="3"
                            v-for="item in (selected_item.opzioni =
                                selected_item.opzioni.length == 0
                                    ? items_opzioni
                                    : selected_item.opzioni)"
                            :key="item.id_tabella"
                        >
                            <v-checkbox
                                v-if="item.val_txt == 'CHECKBOX'"
                                v-model.number="item.val_int"
                                :true-value="1"
                                :false-value="0"
                                :label="item.des"
                            />
                            <v-text-field
                                v-if="item.val_txt == 'TEXT'"
                                dense
                                v-model="item.des"
                                :label="item.cod"
                                hide-details
                                class="mt-5"
                            />
                            <v-textarea
                                v-if="item.val_txt == 'TEXTAREA'"
                                dense
                                rows="1"
                                v-model="item.des"
                                :label="item.cod"
                                hide-details
                                class="mt-4"
                            />
                            <v-autocomplete
                                v-if="item.val_txt == 'SELECT'"
                                v-model="item.val_int1"
                                :label="item.des"
                                :items="
                                    items_opzioni.find(
                                        (i) => i.id_tabella === item.id_tabella
                                    ).valori
                                "
                                item-text="des"
                                item-value="id_tabella"
                                dense
                                hide-details
                                class="mt-5"
                            />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="8">
                    <v-textarea
                        rows="1"
                        v-model="selected_item.descrizione"
                        label="Note"
                        dense
                        hide-details
                        class="mt-5"
                    />
                </v-col>
            </v-row>
            <v-row
                ><div
                    style="height: 1px; width: 100%; background-color: #d1d1d1"
                ></div
            ></v-row>
            <v-row class="ml-2 mt-6">
                <h3>Formulario</h3>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-autocomplete
                        dense
                        v-model.number="servizio.id_tipo_formulario"
                        label="Tipo formulario"
                        :items="items_tipo_formulario"
                        hide-details
                        item-text="des"
                        item-value="val_int"
                        @change="
                            aggiornaItemsAutocomplete();
                            items_causale_formulario = [];
                            servizio.id_causale_formulario = null;
                        "
                    />
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                        dense
                        v-model.number="servizio.id_causale_formulario"
                        label="Causale formulario"
                        :items="items_causale_formulario"
                        hide-details
                        item-text="des"
                        item-value="id_tabella"
                    />
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        v-model.number="selected_item.quantita_origine"
                        label="Qta Origine (Kg)"
                        dense
                        hide-details
                        type="number"
                    />
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        v-model.number="selected_item.quantita_destino"
                        label="Qta Destino (Kg)"
                        dense
                        hide-details
                        type="number"
                    />
                </v-col>
            </v-row>
        </template>

        <!-- Dialog creazione/modifica -->
        <v-dialog persistent v-model="create_edit_dialog" max-width="1200">
            <v-card min-height="70vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        <span
                            v-if="selected_item.id_servizio_dettaglio === null"
                            >Nuovo</span
                        >
                        <span v-else>Modifica</span>
                    </v-toolbar-title>
                    <!-- Salva modifica -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-auto mr-5"
                                @click="salvaDettaglio()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Dettagli</span>
                    </v-tooltip>
                    <!-- Torna indietro -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-auto"
                                @click="
                                    selected_item.opzioni = [];
                                    create_edit_dialog = false;
                                "
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <!-- {{ selected_item }} -->
                    <!-- {{ servizio }} -->
                    <!-- Input -->
                    <v-row justify="center" class="mt-5">
                        <v-col cols="2" v-if="selected_item.codice">
                            <v-text-field
                                :value="selected_item.codice"
                                label="Codice"
                                dense
                                readonly
                                hide-details
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-autocomplete
                                label="Descrizione servizio"
                                v-model.number="
                                    selected_item.id_tipo_servizio_dettaglio
                                "
                                dense
                                hide-details
                                :items="items_dettagli_tipo"
                                item-text="descrizione"
                                item-value="id_tipo_servizio_dettaglio"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-autocomplete
                                @change="getVolumiRifiuti()"
                                v-model.number="selected_item.id_tipo_macchina"
                                label="Tipo rimorchio"
                                dense
                                :items="tipo_veicolo"
                                hide-details
                                item-text="des"
                                item-value="id_tabella"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-autocomplete
                                @change="getVolumiRifiuti()"
                                v-model.number="selected_item.id_tipo_materiale"
                                :items="items_tipo_rifiuto"
                                dense
                                :readonly="
                                    selected_item.id_tipo_macchina == null
                                "
                                @click="
                                    selected_item.id_tipo_macchina == null
                                        ? message(
                                              'Selezionare il tipo rimorchio'
                                          )
                                        : null
                                "
                                label="Tipo Rifiuto"
                                hide-details
                                item-text="descrizione"
                                item-value="id_tipo_materiale"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                label="Materiale"
                                v-model.number="selected_item.id_materiale"
                                dense
                                hide-details
                                :items="items_materiali"
                                item-text="codice_des"
                                item-value="id_materiale"
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="2">
                            <v-autocomplete
                                v-model.number="selected_item.volume"
                                label="Volume"
                                dense
                                @change="
                                    selected_item.volume &&
                                    unita_misura.length > 0
                                        ? (selected_item.um_volume =
                                              unita_misura.find(
                                                  (um) =>
                                                      um.volume ===
                                                      selected_item.volume
                                              ).um_volume)
                                        : null
                                "
                                :items="items_volumi"
                                hide-details
                                :readonly="
                                    selected_item.id_tipo_macchina == null ||
                                    selected_item.id_tipo_materiale == null
                                "
                                @click="
                                    selected_item.id_tipo_macchina == null
                                        ? message(
                                              'Selezionare il tipo rimorchio'
                                          )
                                        : selected_item.id_tipo_materiale ==
                                          null
                                        ? message('Selezionare il tipo rifiuto')
                                        : null
                                "
                                item-text="volume"
                                item-value="volume"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                @click="
                                    selected_item.volume == null ||
                                    selected_item.volume == ''
                                        ? message('Selezionare il volume')
                                        : null
                                "
                                :value="
                                    selected_item.volume &&
                                    unita_misura.length > 0
                                        ? unita_misura.find(
                                              (um) =>
                                                  um.um_volume ===
                                                  selected_item.um_volume
                                          ).misura
                                        : ''
                                "
                                model-value="misura"
                                label="U.M."
                                dense
                                readonly
                                hide-details
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model.number="selected_item.num_big_bag"
                                type="number"
                                label="N° Big Bag"
                                hide-spin-buttons
                                dense
                                hide-details
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="6">
                            <v-text-field
                                @keyup.enter.native="searchListiniArticoli()"
                                :readonly="
                                    this.selected_item.id_articolo != null
                                "
                                v-model="search_articolo"
                                label="Articolo"
                                hide-spin-buttons
                                dense
                                hide-details
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <div class="d-flex bg-surface-variant">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            @click="searchListiniArticoli()"
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            :disabled="
                                                selected_item.id_articolo !=
                                                null
                                            "
                                        >
                                            <v-icon color="primary">
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Trova articoli</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            class="ml-5"
                                            @click="resetArticolo"
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            :disabled="
                                                selected_item.id_articolo ==
                                                null
                                            "
                                        >
                                            <v-icon color="error">
                                                mdi-close
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Rimuovi articolo</span>
                                </v-tooltip>
                            </div>
                        </v-col>

                        <v-col cols="3">
                            <v-text-field
                                v-model.number="
                                    selected_item.frequenza_ripetizione_ore
                                "
                                label="Frequenza ripetizioni"
                                dense
                                hide-details
                                type="number"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-autocomplete
                                v-model.number="
                                    selected_item.um_frequenza_ripetizione
                                "
                                label="U.M."
                                dense
                                hide-details
                                item-text="des"
                                item-value="id_tabella"
                                :items="items_um_tempo"
                            />
                        </v-col>
                        <!-- Colonna padding. -->
                        <!-- <v-col cols="5"></v-col> -->

                        <v-col cols="2">
                            <v-text-field
                                v-model.number="selected_item.costo_servizio"
                                type="number"
                                label="Costo servizio"
                                hide-spin-buttons
                                dense
                                hide-details
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="3">
                            <v-autocomplete
                                v-model.number="selected_item.id_pagamento"
                                label="Tipo Pagamento"
                                dense
                                :items="items_tipo_pagamento"
                                hide-details
                                item-text="des_pagamento"
                                item-value="id_pagamento"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                dense
                                required
                                hide-details
                                label="Intermediario"
                                v-model="selected_item.intermediario"
                                @keyup.enter.native="goToAnagrafica()"
                            >
                                <template v-slot:append>
                                    <v-icon
                                        class="ml-2"
                                        @click="goToAnagrafica()"
                                        color="primary"
                                        >mdi-magnify</v-icon
                                    >
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <!-- ROW per ciclare i campi di input presi dal db -->
                            <v-row>
                                <v-col
                                    cols="4"
                                    v-for="item in (selected_item.opzioni =
                                        selected_item.opzioni.length == 0
                                            ? items_opzioni
                                            : selected_item.opzioni)"
                                    :key="item.id_tabella"
                                >
                                    <v-checkbox
                                        v-if="item.val_txt == 'CHECKBOX'"
                                        v-model.number="item.val_int"
                                        :true-value="1"
                                        :false-value="0"
                                        :label="item.des"
                                    />
                                    <v-text-field
                                        v-if="item.val_txt == 'TEXT'"
                                        dense
                                        v-model="item.des"
                                        :label="item.cod"
                                        hide-details
                                        class="mt-5"
                                    />
                                    <v-textarea
                                        v-if="item.val_txt == 'TEXTAREA'"
                                        dense
                                        rows="1"
                                        v-model="item.des"
                                        :label="item.cod"
                                        hide-details
                                        class="mt-5"
                                    />
                                    <v-autocomplete
                                        v-if="item.val_txt == 'SELECT'"
                                        v-model="item.val_int1"
                                        :label="item.des"
                                        :items="
                                            items_opzioni.find(
                                                (i) =>
                                                    i.id_tabella ===
                                                    item.id_tabella
                                            ).valori
                                        "
                                        item-text="des"
                                        item-value="id_tabella"
                                        dense
                                        hide-details
                                        class="mt-5"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="8">
                            <v-textarea
                                rows="1"
                                v-model="selected_item.descrizione"
                                label="Note"
                                dense
                                hide-details
                                class="mt-5"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        ><div
                            style="
                                height: 1px;
                                width: 100%;
                                background-color: #d1d1d1;
                            "
                        ></div
                    ></v-row>
                    <v-row class="ml-2 mt-6">
                        <h3>Formulario</h3>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-autocomplete
                                dense
                                v-model.number="servizio.id_tipo_formulario"
                                label="Tipo formulario"
                                :items="items_tipo_formulario"
                                hide-details
                                item-text="des"
                                item-value="val_int"
                                @change="
                                    aggiornaItemsAutocomplete();
                                    items_causale_formulario = [];
                                    servizio.id_causale_formulario = null;
                                "
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-autocomplete
                                dense
                                v-model.number="servizio.id_causale_formulario"
                                label="Causale formulario"
                                :items="items_causale_formulario"
                                hide-details
                                item-text="des"
                                item-value="id_tabella"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model.number="selected_item.quantita_origine"
                                label="Qta Origine (Kg)"
                                dense
                                hide-details
                                type="number"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model.number="selected_item.quantita_destino"
                                label="Qta Destino (Kg)"
                                dense
                                hide-details
                                type="number"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64" />
                </v-overlay>
            </v-card>
        </v-dialog>

        <!-- Dialog Stato -->
        <v-dialog persistent v-model="cambia_stato_dialog" max-width="400">
            <v-card min-height="20vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Stato
                    </v-toolbar-title>
                    <v-spacer />
                    <!-- Salva -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="salvaDettaglio()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma</span>
                    </v-tooltip>
                    <v-spacer />
                    <!-- Annulla eliminazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="cambia_stato_dialog = false"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <br />
                <v-card-text class="mt-3">
                    <v-row>
                        <v-col
                            cols="2"
                            class="d-flex justify-center align-center"
                        >
                            <v-icon
                                size="30px"
                                dense
                                :color="
                                    items_stato.filter(
                                        (i) =>
                                            i.id_tabella ==
                                            selected_item.id_stato
                                    ).length > 0
                                        ? items_stato.find(
                                              (i) =>
                                                  i.id_tabella ==
                                                  selected_item.id_stato
                                          ).val_txt
                                        : 'error'
                                "
                            >
                                {{
                                    items_stato.filter(
                                        (i) =>
                                            i.id_tabella ==
                                            selected_item.id_stato
                                    ).length > 0
                                        ? items_stato.find(
                                              (i) =>
                                                  i.id_tabella ==
                                                  selected_item.id_stato
                                          ).nota_interna
                                        : "mdi-close-thick"
                                }}
                            </v-icon>
                        </v-col>
                        <v-col cols="10">
                            <v-autocomplete
                                v-model="selected_item.id_stato"
                                :items="
                                    items_stato.filter((i) =>
                                        selected_item.id_fir != null
                                            ? i.cod != 'A'
                                            : i.cod != 'V'
                                    )
                                "
                                dense
                                hide-details
                                outlined
                                label="Stato"
                                item-text="des"
                                item-value="id_tabella"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog articoli / listini. -->
        <v-dialog persistent v-model="articoli_dialog" width="700px">
            <v-card min-height="30vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Articoli (Listino {{ computeSoggettoListino }})
                    </v-toolbar-title>
                    <v-spacer />

                    <!-- Indietro. -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="articoli_dialog = false"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error"
                                    >mdi-keyboard-backspace</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Indietro</span>
                    </v-tooltip>
                </v-toolbar>

                <br />

                <v-data-table
                    fixed-header
                    :headers="headers_articoli"
                    :items="items_articoli"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                >
                    <template v-slot:[`item.select`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    @click="
                                        articoli_dialog = false;
                                        setArticolo(item);
                                    "
                                >
                                    <v-icon color="primary">mdi-check</v-icon>
                                </v-btn>
                            </template>
                            <span>Seleziona</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:[`item.prezzo`]="{ item }">
                        <div style="text-align: right">
                            {{ formatCurrency(item.prezzo) }} €
                        </div>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>

        <!-- Dialog Delete -->
        <v-dialog persistent v-model="delete_dialog" max-width="700">
            <v-card min-height="30vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Elimina
                    </v-toolbar-title>
                    <v-spacer />
                    <!-- Conferma eliminazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="deleteDettaglio()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma</span>
                    </v-tooltip>
                    <v-spacer />
                    <!-- Annulla eliminazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="delete_dialog = false"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <br />
                <v-card-text class="mt-10">
                    <p class="black--text">
                        Sei sicuro di voler eliminare l'opzione
                        {{ selected_item.codice }}?
                    </p>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- DIALOG RICERCA RAGIONE SOCIALE -->
        <v-dialog v-model="dialog_search_aziende" width="50%" persistent>
            <v-card>
                <v-toolbar color="indigo" dense dark>
                    <v-toolbar-title>Seleziona Ragione Sociale</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog_search_aziende = false" light small>
                        <v-icon color="error">mdi-keyboard-backspace</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="headers_azienda"
                                    :items="items_azienda"
                                >
                                    <template
                                        v-slot:[`item.seleziona`]="{ item }"
                                    >
                                        <v-btn
                                            small
                                            @click="
                                                selected_item.intermediario =
                                                    item.ragione_sociale;
                                                dialog_search_aziende = false;
                                            "
                                        >
                                            <v-icon color="primary"
                                                >mdi-check</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>
    </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
// import moment from "moment/moment";

class Dettaglio {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }
    setCampi() {
        const campi = [
            { nome: "id_servizio_dettaglio", default_val: null },
            { nome: "id_servizio", default_val: null },
            { nome: "id_tipo_materiale", default_val: null },
            { nome: "id_tipo_servizio_dettaglio", default_val: null },
            { nome: "frequenza_ripetizione_ore", default_val: 0 },
            { nome: "quantita_origine", default_val: 0 },
            { nome: "quantita_destino", default_val: 0 },
            { nome: "um_frequenza_ripetizione", default_val: 392 },
            { nome: "id_tipo_macchina", default_val: null },
            { nome: "id_stato", default_val: null },
            { nome: "id_materiale", default_val: "" },
            { nome: "volume", default_val: null },
            { nome: "um_volume", default_val: null },
            { nome: "costo_servizio", default_val: 0 },
            { nome: "id_articolo", default_val: null },
            { nome: "des_articolo", default_val: null },
            { nome: "id_listino", default_val: null },
            { nome: "credito_azienda", default_val: 0 },
            { nome: "num_big_bag", default_val: 0 },
            { nome: "id_pagamento", default_val: null },
            { nome: "intermediario", default_val: "" },
            { nome: "descrizione", default_val: "" },
            { nome: "opzioni", default_val: [] },
            { nome: "codice", default_val: "" },
            { nome: "id_fir", default_val: null },
            { nome: "seriale_fir", default_val: "" },
            { nome: "qr_key_fir", default_val: "" },
            { nome: "data_richiesta_fir", default_val: "" },
            { nome: "codice_soggetto_richiesta_fir", default_val: "" },
            { nome: "descrizione_soggetto_richiesta_fir", default_val: "" },
            { nome: "id_tipo_formulario", default_val: "" },
            { nome: "id_causale_formulario", default_val: "" },
            { nome: "validita", default_val: 1 },
        ];
        return campi;
    }
}

export default {
    name: "QLOpzioniServizi",

    components: {
        SnackbarQV,
    },

    props: {
        servizio: Object,
        id_pagamento_default: Number,
        id_azienda: Number,
    },

    data() {
        return {
            // Variabili d'appoggio
            selected_item: new Dettaglio(),
            servizio_wrapper: {},
            azienda_detail: {},
            selected_azienda: {},
            // Filtri
            filters: false,
            overlay: false,
            codice_filter: "",
            id_tipo_servizio_dettaglio_filter: "",
            id_tipo_macchina_filter: "",
            id_materiale_filter: "",
            search_articolo: "",
            search_azienda: "",
            // Variabili tabella/crea/modifica
            cambia_stato_dialog: false,
            articoli_dialog: false,
            create_edit_dialog: false,
            delete_dialog: false,
            dialog_search_aziende: false,
            // Array
            tot_dettagli_servizio: [],
            items_dettagli_servizio: [],
            items_materiali: [],
            items_opzioni: [],
            items_volumi: [],
            items_tipo_rifiuto: [],
            items_tipo_pagamento: [],
            tot_items_tipo_rifiuto: [],
            tipo_veicolo: [],
            unita_misura: [],
            items_um_tempo: [],
            items_dettagli_tipo: [],
            items_stato: [],
            items_articoli: [],
            items_azienda: [],

            // Headers articoli
            headers_azienda: [
                {
                    text: "",
                    value: "seleziona",
                    sortable: false,
                    width: "120px",
                },
                { text: "Cod. Cliente", value: "codice_univoco" },
                { text: "Ragione sociale", value: "ragione_sociale" },
                { text: "P. IVA", value: "piva" },
                { text: "Indirizzo", value: "indirizzo" },
            ],
            headers_articoli: [
                {
                    text: "Seleziona",
                    value: "select",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Cod. Articolo",
                    value: "cod_articolo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Descrizione",
                    value: "des_articolo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Prezzo",
                    value: "prezzo",
                    filterable: false,
                    sortable: false,
                    width: "150px",
                },
            ],

            // Headers Tabella
            headers: [
                {
                    text: "Modifica",
                    value: "edit",
                    filterable: false,
                    sortable: false,
                    width: "100px",
                },
                {
                    text: "Richiesta fir",
                    value: "fir",
                    filterable: false,
                    sortable: false,
                    width: "100px",
                },
                {
                    text: "Report",
                    value: "report",
                    filterable: false,
                    sortable: false,
                    width: "100px",
                },
                // {
                //   text: "Stampa",
                //   value: "PDFFormulario",
                //   filterable: false,
                //   sortable: false,
                //   width: "100px",
                // },
                {
                    text: "Invia Dati",
                    value: "InviaDati",
                    filterable: false,
                    sortable: false,
                    width: "100px",
                },
                {
                    text: "Cambia Stato",
                    value: "changestato",
                    filterable: false,
                    sortable: false,
                    width: "100px",
                },
                {
                    text: "Codice",
                    value: "codice",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tipo Rimorchio",
                    value: "id_tipo_macchina",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Volume",
                    value: "volume",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Descrizione",
                    value: "id_tipo_servizio_dettaglio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Materiale",
                    value: "id_tipo_materiale",
                    filterable: false,
                    sortable: false,
                },
                /*{
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
          width: "100px",
        },*/
            ],
            items_attesa_carico_um: [],
            items_causale_formulario: [],
            items_tipo_formulario: [],
            items_zona: [],
        };
    },

    computed: {
        computeSoggettoListino: function () {
            let tipo_listino = "";
            if (this.items_articoli.length > 0)
                switch (this.items_articoli[0].tipo_soggetto) {
                    case "S":
                        tipo_listino = "sede";
                        break;

                    case "C":
                        tipo_listino = "cliente";
                        break;

                    case "B":
                        tipo_listino = "base";
                        break;
                }
            return tipo_listino;
        },
    },

    watch: {
        id_azienda: {
            immediate: true,
            handler() {},
        },
    },

    methods: {
        aggiornaItemsAutocomplete() {
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "'EG_ZONA','TIPO_FORMULARIO'",
                    filter: `validita = 1`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_tipo_formulario = res.data.TIPO_FORMULARIO
                        ? res.data.TIPO_FORMULARIO
                        : [];
                    console.log("");
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });

            const causale_formulario = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "CAUSALE_FORMULARIO",
                    filter:
                        "validita = 1 && val_int1 = '" +
                        this.servizio.id_tipo_formulario +
                        "'",
                },
            };

            if (this.servizio.id_tipo_formulario)
                this.$store.dispatch("api", causale_formulario).then((res) => {
                    this.overlay = false;
                    if (res.status == 200 || res.status == 204) {
                        console.log("reeeeessss", res);
                        this.items_causale_formulario = res.data
                            ? res.data
                            : [];
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                });

            const um_attesa = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "UNITA_MISURA",
                    filter: `validita = 1 && val_txt='H'`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", um_attesa).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_attesa_carico_um = res.data ? res.data : [];
                    console.log(
                        "items_attesa_carico_um ==>",
                        this.items_attesa_carico_um
                    );
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },
        goToAnagrafica() {
            const getragionesociale = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getaziende",
                    ragione_sociale: this.selected_item.intermediario,
                    piva: "",
                    codice_univoco: "",
                },
            };

            this.overlay = true;
            return this.$store
                .dispatch("api6", getragionesociale)
                .then((res) => {
                    this.overlay = false;

                    if (res.data.result.length > 1) {
                        this.items_azienda = res.data.result;
                        this.dialog_search_aziende = true;
                    }

                    if (res.data.result.length === 0) {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Non sono state trovate ragioni sociali con questo nome."
                        );
                    }

                    if (res.data.result.length === 1) {
                        this.items_azienda = res.data.result;
                        this.selected_item.intermediario =
                            res.data.result[0].ragione_sociale;
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                    this.overlay = false;
                });
        },
        // Servizio selezionato
        selectItem(item) {
            this.selected_item.opzioni = [];
            this.selected_item = new Dettaglio(
                JSON.parse(JSON.stringify(item))
            );
            if (this.selected_item.opzioni.length == 0) {
                this.selected_item.opzioni = Array.from(this.items_opzioni);
            }
            this.getVolumiRifiuti();
        },

        aggiornaItems() {
            this.getPagamenti();

            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "STATO_SERVIZIO_DETTAGLIO",
                    filter: `validita = 1`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_stato = res.data ? res.data : [];
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },

        setArticolo(item) {
            this.search_articolo = item.des_articolo;
            this.selected_item.id_articolo = item.id_articolo;
            this.selected_item.costo_servizio = item.prezzo;
            this.selected_item.id_listino = item.id_listino;
        },

        searchListiniArticoli() {
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "getlistinibyarticoli",
                    token: localStorage.getItem("user_token"),
                    articoli: this.search_articolo,
                },
            };

            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.items_articoli = res.data.result;

                        if (this.items_articoli.length == 0) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Nessun articolo trovato."
                            );
                            return;
                        } else {
                            // Listini articoli per determinata anagrafica e sede.
                            let listini_sede = this.items_articoli.filter(
                                (e) =>
                                    e.tipo_soggetto == "S" &&
                                    e.id_anagrafica == this.id_azienda &&
                                    this.servizio.id_sede_arrivo ==
                                        e.id_anagrafica_sede
                            );
                            // Listini articoli per determinata anagrafica.
                            let listini_clienti = this.items_articoli.filter(
                                (e) =>
                                    e.tipo_soggetto == "C" &&
                                    e.id_anagrafica == this.id_azienda
                            );
                            // Listini generali.
                            let listini_base = this.items_articoli.filter(
                                (e) => e.tipo_soggetto == "B"
                            );

                            if (listini_sede.length > 0) {
                                if (listini_sede.length == 1)
                                    this.setArticolo(listini_sede[0]);
                                else {
                                    this.articoli_dialog = true;
                                    this.items_articoli = listini_sede;
                                }
                            } else if (listini_clienti.length > 0) {
                                if (listini_clienti.length == 1)
                                    this.setArticolo(listini_clienti[0]);
                                else {
                                    this.articoli_dialog = true;
                                    this.items_articoli = listini_clienti;
                                }
                            } else if (listini_base.length > 0) {
                                if (listini_base.length == 1)
                                    this.setArticolo(listini_base[0]);
                                else {
                                    this.articoli_dialog = true;
                                    this.items_articoli = listini_base;
                                }
                            } else {
                                this.$refs.SnackbarQV.print(
                                    "orange",
                                    "Nessun listino trovato."
                                );
                                return;
                            }
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                });
        },

        getPagamenti() {
            let request = {
                controller: "contabilita",
                method: "POST",
                richiesta: {
                    action: "getpagamento",
                    token: localStorage.user_token,
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        this.items_tipo_pagamento = res.data.result
                            ? res.data.result.pagamento
                            : [];
                    } else {
                        console.log("error: " + res.data.statusCode);
                    }
                })
                .catch((err) => {
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    ); // Stampo il log dell'errore in console.
                    console.error(err);
                });
        },

        async generaFir(item) {
            await this.selectItem(item);

            const request = {
                controller: "wsViViFir",
                method: "POST",
                richiesta: {
                    action: "generafirblocco",
                    token: localStorage.user_token,
                    codice_blocco: "VYPG",
                    id_servizio_dettaglio: item.id_servizio_dettaglio,
                },
            };
            console.log("[generaFir] Richiesta", { request });
            this.overlay = true;
            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    console.log("[generaFir] Risposta", {
                        status: res.status,
                        data: res.data,
                    });
                    if (res.status === 200) {
                        if (
                            res.data.seriale &&
                            res.data.seriale.startsWith("Error:")
                        ) {
                            // Mostra dettaglio errore
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.seriale.replace("Error: ", "")
                            );
                            this.overlay = false;
                        } else {
                            this.selected_item.id_fir = res.data.progressivo;
                            this.selected_item.qr_key_fir = res.data.qrKey;
                            this.selected_item.seriale_fir = res.data.seriale;
                            this.selected_item.data_richiesta_fir =
                                res.data.dataRichiesta;
                            this.selected_item.codice_soggetto_richiesta_fir =
                                res.data.codiceFiscaleSoggetto;
                            this.selected_item.descrizione_soggetto_richiesta_fir =
                                res.data.denominazioneSoggetto;
                            this.selected_item.id_stato = this.items_stato.find(
                                (i) => i.des == "Aperto"
                            ).id_tabella;
                            this.salvaDettaglio(1);
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile caricare i dati.`
                        );
                        this.overlay = false;
                    }
                })
                .catch((err) => {
                    console.error("[generaFir] Errore", err);
                    this.overlay = false;
                });
        },

        async getAziende() {
            const getragionesociale = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getaziende",
                    id_anagrafica: this.id_azienda,
                },
            };
            this.overlay = true;
            return this.$store
                .dispatch("api6", getragionesociale)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        if (res.data.result.length > 0)
                            this.azienda_detail = res.data.result[0];
                        return true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                        return false;
                    }
                });
        },

        async getReport(item) {
            await this.selectItem(item);

            const request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: "formulario_rifiuti",
                    parametri: [
                        {
                            parametro: "@id_servizio",
                            valore: this.selected_item.id_servizio,
                        },
                    ],
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        this.showPdfViewer(res.data.result);
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    }
                })
                .catch((err) => {
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                    console.error(err);
                });
        },
        // prendi i Dettagli Servizio dal db
        getDettagliServizio() {
            if (this.servizio.id_servizio != null) {
                const getserviziodettagli = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "getserviziodettagli",
                        id_servizio: this.servizio.id_servizio,
                    },
                };
                this.overlay = true;
                this.$store
                    .dispatch("api6", getserviziodettagli)
                    .then((res) => {
                        this.overlay = false;
                        if (res.status === 200) {
                            this.tot_dettagli_servizio = [];
                            res.data.result.forEach((e) => {
                                if (e.validita === 1) {
                                    this.tot_dettagli_servizio.push(e);
                                }
                            });
                            this.items_dettagli_servizio = Array.from(
                                this.tot_dettagli_servizio
                            );
                            this.$emit("dettaglio_caricato");
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                            );
                        }
                    });
            } else {
                this.$emit("dettaglio_caricato");
            }
        },
        showPdfViewer(base64) {
            const b64toBlob = (b64Data, sliceSize = 512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];
                for (
                    let offset = 0;
                    offset < byteCharacters.length;
                    offset += sliceSize
                ) {
                    const slice = byteCharacters.slice(
                        offset,
                        offset + sliceSize
                    );

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: "application/pdf" });
                return blob;
            };
            const blob = b64toBlob(base64);
            const blob_url = URL.createObjectURL(blob);
            // apre la pagina con l'anteprima del pdf del qr creato dal BE
            window.open(blob_url, "_blank");
        },
        nuovoDettaglio() {
            this.items_volumi = [];
            this.items_articoli = [];
            this.selected_item = new Dettaglio();
            this.search_articolo = "";

            if (this.id_pagamento_default != null) {
                this.selected_item.id_pagamento = this.id_pagamento_default;
            }
            this.selected_item.opzioni = Array.from(this.items_opzioni);
            this.selected_item.id_stato =
                this.items_stato.filter((s) => s.cod == "A").length > 0
                    ? this.items_stato.find((s) => s.cod == "A").id_tabella
                    : null;
            this.create_edit_dialog = true;
        },
        message(message) {
            this.$refs.SnackbarQV.print("orange", message);
        },
        // Salva
        async salvaDettaglio(snackbar) {
            this.servizio_wrapper.id_tipo_formulario =
                this.servizio.id_tipo_formulario;
            this.servizio_wrapper.id_causale_formulario =
                this.servizio.id_causale_formulario;
            this.selected_item.id_servizio = this.servizio.id_servizio;

            if (this.selected_item.frequenza_ripetizione_ore < 0) {
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Frequenza ripetizione in ore necessaria per pianificare"
                );
            }
            if (
                this.selected_item.id_tipo_servizio_dettaglio == null ||
                this.selected_item.id_tipo_servizio_dettaglio == ""
            ) {
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire una descrizione servizio"
                );
            }
            if (
                this.selected_item.id_tipo_macchina == null ||
                this.selected_item.id_tipo_macchina == ""
            ) {
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire un tipo rimorchio"
                );
            }
            if (
                this.selected_item.volume == null ||
                this.selected_item.volume == ""
            ) {
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire il volume"
                );
            }
            if (
                this.selected_item.id_tipo_materiale == null ||
                this.selected_item.id_tipo_materiale == ""
            ) {
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire il tipo rifiuto"
                );
            }
            if (
                (this.selected_item.id_servizio_dettaglio == null ||
                    this.selected_item.id_stato == null) &&
                this.items_stato.length > 0
            ) {
                // Stato aperto di default
                await this.getAziende();

                let codice_stato = "A";
                if (this.azienda_detail)
                    codice_stato =
                        this.azienda_detail.id_blocco_fido > 0 ? "B" : "A";

                this.selected_item.id_stato =
                    this.items_stato.filter((s) => s.cod == codice_stato)
                        .length > 0
                        ? this.items_stato.find((s) => s.cod == codice_stato)
                              .id_tabella
                        : null;
            }
            this.servizio_wrapper.errori = null;
            this.servizio_wrapper.id_articolo = this.selected_item.id_articolo;
            this.servizio_wrapper.id_listino = this.selected_item.id_listino;

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "saveservizio",
                    token: localStorage.getItem("user_token"),
                    servizio: this.servizio_wrapper,
                    dettagli: [this.selected_item],
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", request).then((res) => {
                this.overlay = false;
                if (res.status == 200 || res.status == 204) {
                    this.$emit("GetDettagliServizio");
                    this.getDettagliServizio();
                    // se la snackbar e a 1 vuol dire che la funzione salvaDettaglio
                    // e stata eseguita dopo la generazione del fir
                    if (snackbar == 1) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Fir generato correttamente."
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Modifiche salvate correttamente."
                        );
                    }
                } else {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });

            // if (this.id_pagamento_default != null) {
            //   this.selected_item.id_pagamento = this.id_pagamento_default;
            // }
            this.create_edit_dialog = false;
            this.cambia_stato_dialog = false;
        },
        // Elimina
        deleteDettaglio() {
            this.selected_item.validita = 0;
            this.servizio_wrapper.errori = null;
            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "saveservizio",
                    token: localStorage.getItem("user_token"),
                    servizio: this.servizio_wrapper,
                    dettagli: [this.selected_item],
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", request).then(() => {
                this.overlay = false;
                this.$emit("GetDettagliServizio");
                this.getDettagliServizio();
                this.$refs.SnackbarQV.print(
                    "success",
                    "Modifica effettuata con successo!"
                );
            });
            this.selected_item = new Dettaglio();

            if (this.id_pagamento_default != null) {
                this.selected_item.id_pagamento = this.id_pagamento_default;
            }
            this.delete_dialog = false;
        },
        getVolumiRifiuti() {
            this.items_volumi = [];
            this.unita_misura = [];

            if (this.selected_item.id_tipo_macchina == null) {
                return;
            }
            const tipo_rifiuto = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "gettipomateriale",
                    token: localStorage.getItem("user_token"),
                    id_tipo_veicolo: this.selected_item.id_tipo_macchina,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", tipo_rifiuto).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_tipo_rifiuto = res.data.result
                        ? res.data.result
                        : [];
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });

            if (this.selected_item.id_tipo_materiale == null) {
                return;
            }
            const getvolumi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getvolumi",
                    id_tipo_macchina: this.selected_item.id_tipo_macchina,
                    id_tipo_materiale: this.selected_item.id_tipo_materiale,
                },
            };
            this.$store.dispatch("api6", getvolumi).then((res) => {
                if (res.status === 200) {
                    this.items_volumi = res.data.result ? res.data.result : [];
                    res.data.result.forEach((um) => {
                        if (this.unita_misura.includes(um) === false)
                            this.unita_misura.push(um);
                    });
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        aggiornaAutocomplete() {
            const um_tempo = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "UNITA_MISURA",
                    filter: `validita = 1 && val_txt='H'`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", um_tempo).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_um_tempo = res.data ? res.data : [];
                    // console.table(this.unita_misura);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
            const opzioni = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "getopzioni",
                    token: localStorage.getItem("user_token"),
                    filter: `validita = 1`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", opzioni).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_opzioni = res.data.result ? res.data.result : [];
                    console.log("opzioni BE ==>", this.items_opzioni);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
            const tipo_veicolo = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "EG_TIPO_VEICOLO",
                    filter: `validita = 1 && id_tabella!=33570`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", tipo_veicolo).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.tipo_veicolo = res.data ? res.data : [];
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
            const gettiposerviziodettagli = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "gettiposerviziodettagli",
                    id_tipo_servizio: null,
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api6", gettiposerviziodettagli)
                .then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        this.items_dettagli_tipo = [];
                        this.items_dettagli_tipo = res.data.result
                            ? res.data.result
                            : [];
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    }
                });
            const getmateriali = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getmateriali",
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", getmateriali).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.items_materiali = res.data.result
                        ? res.data.result
                        : [];
                    this.items_materiali.forEach((e) => {
                        e.codice_des = e.codice_cer + " - " + e.descrizione;
                    });
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
            const tipo_rifiuto = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "gettipomateriale",
                    token: localStorage.getItem("user_token"),
                    id_tipo_veicolo: null,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", tipo_rifiuto).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.tot_items_tipo_rifiuto = res.data.result
                        ? res.data.result
                        : [];
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },
        // Filtri
        filtra() {
            /* Preparo un array temporaneo in cui
             * collezionare i Servizi filtrati */
            let dettagli_tmp = [];
            this.tot_dettagli_servizio.forEach((v) => {
                dettagli_tmp.push(new Dettaglio(v));
            });

            // Filtro per tipo_servizio_dettaglio
            if (
                this.id_tipo_servizio_dettaglio_filter !== "" &&
                typeof this.id_tipo_servizio_dettaglio_filter !== "object"
            ) {
                let res = [];
                dettagli_tmp.forEach((elem) => {
                    if (
                        elem.id_tipo_servizio_dettaglio ==
                        this.id_tipo_servizio_dettaglio_filter
                    ) {
                        res.push(new Dettaglio(elem));
                    }
                });
                dettagli_tmp = [];
                res.forEach((e) => {
                    dettagli_tmp.push(new Dettaglio(e));
                });
            }

            // Filtro per tipo_macchina
            if (
                this.id_tipo_macchina_filter !== "" &&
                typeof this.id_tipo_macchina_filter !== "object"
            ) {
                let res = [];
                dettagli_tmp.forEach((elem) => {
                    if (elem.id_tipo_macchina == this.id_tipo_macchina_filter) {
                        res.push(new Dettaglio(elem));
                    }
                });
                dettagli_tmp = [];
                res.forEach((e) => {
                    dettagli_tmp.push(new Dettaglio(e));
                });
            }
            // Filtro per materiale
            if (
                this.id_materiale_filter !== "" &&
                typeof this.id_materiale_filter !== "object"
            ) {
                let res = [];
                dettagli_tmp.forEach((elem) => {
                    if (elem.id_materiale == this.id_materiale_filter) {
                        res.push(new Dettaglio(elem));
                    }
                });
                dettagli_tmp = [];
                res.forEach((e) => {
                    dettagli_tmp.push(new Dettaglio(e));
                });
            }

            //Filtro per codice
            if (this.codice_filter != "") {
                let res = [];
                dettagli_tmp.forEach((e) => {
                    if (
                        e.codice
                            .toUpperCase()
                            .includes(this.codice_filter.toUpperCase())
                    ) {
                        res.push(new Dettaglio(e));
                    }
                });
                dettagli_tmp = [];
                res.forEach((e) => {
                    dettagli_tmp.push(new Dettaglio(e));
                });
            }
            // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.
            this.items_dettagli_servizio = [];
            this.items_dettagli_servizio = Array.from(dettagli_tmp);
        },

        formatCurrency(arg) {
            return arg
                ? Intl.NumberFormat("de-DE", {
                      minimumFractionDigits: 2,
                  }).format(arg)
                : "";
        },
        resetFiltri() {
            this.codice_filter = "";
            // this.id_tipo_servizio_filter = "";
            this.id_tipo_servizio_dettaglio_filter = "";
            this.id_tipo_macchina_filter = "";
            this.id_materiale_filter = "";
            this.filtra();
        },

        resetArticolo() {
            this.selected_item.id_articolo = null;
            this.selected_item.id_listino = null;
            this.search_articolo = "";
        },

        inviaDatiFormulario(item) {
            if (
                !this.servizio.id_tipo_formulario ||
                !this.servizio.id_causale_formulario
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "I campi 'Tipo Formulario' e 'Causale Formulario' sono necessari prima di procedere."
                );
                return;
            }

            const request = {
                controller: "Prometeo",
                method: "PUT",
                richiesta: {
                    action: "setformulario",
                    token: localStorage.getItem("user_token"),
                    id_servizio: item.id_servizio,
                },
            };
            console.log(request);
            this.overlay = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    console.log(res);
                    this.overlay = false;
                    if (res.status == 200) {
                        let successMessage = "Dati inviati correttamente.";
                        if (res.data && res.data.message) {
                            successMessage = res.data.message;
                        }
                        this.$refs.SnackbarQV.print("success", successMessage);
                    } else {
                        let errorMessage =
                            "Errore di comunicazione col server, non è stato possibile caricare i dati.";
                        if (res.data && res.data.error) {
                            errorMessage = res.data.error;
                        }
                        this.$refs.SnackbarQV.print("orange", errorMessage);
                    }
                })

                .catch((e) => {
                    console.error(
                        "Caught an exception during API call or processing:",
                        e
                    );
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore: " + e.message
                    );
                });
        },

        async getPDFFormulario(item) {
            const request = {
                controller: "Prometeo",
                method: "POST",
                richiesta: {
                    action: "getpdfformulario",
                    token: localStorage.getItem("user_token"),
                    id_formulario: item.id_servizio,
                },
            };

            console.log("[getPDFFormulario] Richiesta", request);

            this.overlay = true;
            try {
                const res = await this.$store.dispatch("api", request);
                this.overlay = false;
                const base64String = res.data?.value?.base64;
                if (res.status == 200 && base64String) {
                    const b64toBlob = async (
                        b64Data,
                        contentType = "application/pdf"
                    ) => {
                        const response = await fetch(
                            `data:${contentType};base64,${b64Data}`
                        );
                        return await response.blob();
                    };

                    const blob = await b64toBlob(base64String);
                    const blobUrl = URL.createObjectURL(blob);
                    const now = new Date();
                    const dateString = [
                        now.getDate().toString().padStart(2, "0"),
                        (now.getMonth() + 1).toString().padStart(2, "0"),
                        now.getFullYear().toString().slice(-2),
                        "T",
                        now.getHours().toString().padStart(2, "0"),
                        now.getMinutes().toString().padStart(2, "0"),
                    ].join("");

                    const downloadLink = document.createElement("a");
                    downloadLink.href = blobUrl;
                    downloadLink.download = `formulario_${dateString}_${item.id_servizio}.pdf`;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                    URL.revokeObjectURL(blobUrl);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            } catch (e) {
                this.overlay = false;
                this.$refs.SnackbarQV.print("error", "Errore: " + e.message);
            }
        },
    },

    created() {},

    mounted() {
        this.getDettagliServizio();
        this.aggiornaItems();
        this.aggiornaAutocomplete();
        this.aggiornaItemsAutocomplete();
        this.servizio_wrapper = JSON.parse(JSON.stringify(this.servizio));
        this.servizio_wrapper.colore_sfondo =
            this.servizio_wrapper.colore_sfondo.hex;
        this.servizio_wrapper.colore_testo =
            this.servizio_wrapper.colore_testo.hex;
        console.log(this.servizio);
        if (this.selected_item.id_servizio_dettaglio < 0) {
            this.selected_item.id_pagamento = this.id_pagamento_default;
        }
    },
};
</script>

<style scoped></style>
